<template>
<div class="indexPage" style="height: 100%;">

    <headfix></headfix>
    <div class="common-banner">
        <div class="bg-img" v-for="(item,index) in advList">
           <img :src="item.advImages" class="pc" @click="goAdv_(item)"/>
           <img :src="item.advSmallImages1" class="mobile" @click="goAdv_(item)"/>
       </div>
    </div>

    <div class="wraper-box" style="position: relative;">
        <div class="tit-box">
           <div class="art-cate-title">
               <div class="art-cate-title-top">沃兴坚持</div>
               <div class="art-cate-title-center">将透明的行业呈现给用户</div>
               <div class="art-cate-title-bottom"><span class="t1">PRESENT</span><span class="t2"> A TRANSPARENT INDUSTRY TO USERS</span></div>
           </div>

            <div class="share">
                <div class="share-list">
                    <a href="javascript:;" class="share-item s1" :style="{backgroundImage: 'url(' + setting.kuaishouCode + ')', backgroundSize:'100% 100%', backgroundRepeat: 'no-repeat'}"><span><img :src="setting.xiaohongshuCode"/></span></a>
                    <a href="javascript:;" class="share-item s2" :style="{backgroundImage: 'url(' + setting.douyinCode + ')', backgroundSize:'100% 100%', backgroundRepeat: 'no-repeat'}"><span><img :src="setting.shipingCode"/></span></a>
                    <div class="clearfix"></div>
                </div>
                <div class="share-desc">扫码了解更多资讯</div>
            </div>
            <div class="clearfix"></div>
        </div>

        <div class="art-hot-list">
            <a class="art-hot-item" v-for="(item,index) in hotList" @click="goArticleDetail(item)">
                <div class="item-pic"><img :src="item.thumb"></div>
                <div class="item-content">
                    <div class="item-left">
                        <div class="item-title">{{item.title}}</div>
                        <div class="item-short-title">{{item.keywords}}</div>
                    </div>
                    <div class="item-detail"><a href="javascript:;">查看详情</a></div>
                </div>
                <div class="create-time">{{item.createTime | getMyDate}}</div>
            </a>
        </div>

        <div class="art-list">
            <a class="art-item" v-for="(item,index) in articleList" @click="goArticleDetail(item)">
                <div class="art-no">{{index < 9 ? "0" + (index + 1) : (index + 1)}}</div>
                <div class="art-title">
                    <div class="t1">{{item.title}}</div>
                    <div class="t2">{{item.keywords}}</div>
                </div>
                <div class="art-time">{{item.createTime | getMyDate}}</div>
                <i class="icon"></i>
            </a>
            <div class="clearfix"></div>
        </div>

        <div class="pageStyle">
            <qspage
                    :page-index="page"
                    :total="total"
                    :page-size="pageSize"
                    @change="pageChange">
            </qspage>
        </div>




    </div>
    <footerfix></footerfix>



</div>
</template>
<script>
import headfix from '@/components/utils/headfix';
import footerfix from '@/components/utils/footerfix';
import {settingInfo_, categoryTree_, goCate_, goAdv_} from '@/components/js/app'
import qspage from '@/components/utils/qspage';
export default {
    components:{headfix, footerfix, qspage},
    data(){
        return{
            page:1,
            pageSize:5,
            total : 0, //总记录数
            categoryInfo:{},
            advList:[],
            setting:{},
            hotList:[],
            articleList:[],
            tabIndex:-1,
            currentId:0,
        }
    },
    mounted() {
          document.querySelector('body').setAttribute('style', 'background-color:#faf9f5')
       },
    created() {
        this.currentId = this.$route.query.cateId;
        this.$nextTick(()=>{
           this.getCategoryData(this.currentId);
           this.settingInfo();
           if (this.currentId == 47) {
              this.getAdvData(63);
           }
            this.getHotListData(this.currentId);
            this.getArticleListData(this.currentId);
        })
    },
    methods : {
       goCate_,
       goAdv_,
      // 分类详情
      getCategoryData (categoryId) {
          this.$post_('api/cms-category/info', {id: categoryId}, (res) => {
              if (res.code == 1) {
                  this.categoryInfo = res.data;
              } else {
                  this.$message.error(res.message);
              }
          })
      },
      // 分类广告
      getAdvData (positionId) {
          this.$post_('api/adv/adv-list', {catId: positionId}, (res) => {
              if (res.code == 1) {
                  this.advList = res.data;
              } else {
                  this.$message.error(res.message);
              }
          })
      },
      // 热门文章列表
      getHotListData (categoryId) {
           let data = {
               categoryId:categoryId,
               attr1: 1
           }
           this.$post_('api/cms-article/article-page', {page:1,size:2, data:data}, (res) => {
               if (res.code == 1) {
                   this.hotList = res.data.records;
               } else {
                   this.$message.error(res.message);
               }
           })
       },
      // 文章列表
      getArticleListData (categoryId) {
           let data = {
               categoryId:categoryId,
               noAttr1: 1
           }
           this.$post_('api/cms-article/article-page', {page:this.page, size: this.pageSize, data:data}, (res) => {
               if (res.code == 1) {
                   this.articleList = res.data.records;
                   this.total = Number(res.data.total);
               } else {
                   this.$message.error(res.message);
               }
           })
       },

       // 配置信息
       settingInfo() {
         settingInfo_((res) => {
             if (res.code == 1) {
                 this.setting = res.data;
             } else {
                 this.$message.error(res.message);
             }
         }, false);
       },

       goArticleDetail(item) {
           this.$router.push({path:'/articleDetail', query:{cateId:item.categoryId, id:item.id}});
       },
       pageChange (page) {
           this.page = page
           this.getArticleListData(this.currentId);
       }

    }
}
</script>

<style scoped>


.tit-box{margin-top: 40px;}
.art-cate-title{width: 600px;float: left;}
.art-cate-title-top{font-size: 40px;font-weight: 600;color: #000000;}
.art-cate-title-center{font-size: 40px;font-weight: 600;color: #000000;}
.art-cate-title-bottom{font-size: 20px;}
.art-cate-title-bottom .t1{color:#e46a27;}
.art-cate-title-bottom .t2{color: #1f1f1f;}


.share{float: right;width: 260px;}
.share-list{}
.share-item{position: relative;}
.share-item span{z-index:9999999999;background:#FFFFFF;display: inline-block;height: 200px;width: 200px;
    border-radius:10px;position: absolute;left: 50%;margin-left: -100px;bottom: 140px;
    box-shadow: 0 0 10px rgb(0 0 0 / 30%);transition: all 0.3s ease-in-out;opacity: 0;visibility: hidden;
    transform: translateY(8px) scale(0.6);transform-origin: center bottom;padding: 20px;}
.share-item:hover span{opacity: 1;visibility: visible;transform: translateY(0) scale(1);}
.share-item:hover span img{width: 100%;height: 100%;object-fit: cover;}
.share-item span:after{content: "";border-left: 8px solid transparent;border-right: 8px solid transparent;
    border-top: 8px solid #fff;position: absolute;left: 50%;margin-left: -4px;bottom: -7px;}
.share-item.s1{width: 100px;height: 100px;float: left;}
.share-item.s2{width: 100px;height: 100px;float: right;}



.share-desc{margin-top: 10px;text-align: center;font-size: 16px;}

.art-hot-list{display: flex;justify-content: space-between;margin-top: 40px;}
.art-hot-item{width: calc(50% - 30px);cursor: pointer;}
.art-hot-item .item-pic{height: 300px;}
.art-hot-item .item-pic img{width: 100%;height: 100%;object-fit: cover;}
.art-hot-item .item-content{display: flex;justify-content: space-between;align-items: center;margin-top: 20px;}
.item-content .item-left{flex: 1;}
.item-left .item-title{font-size: 20px;font-weight: 500;}
.item-left .item-short-title{font-size: 14px;color: #555555;}
.item-detail{border: #CCCCCC 1px solid;text-align: center;color: #CCCCCC;padding: 4px 8px;font-size: 12px;margin-left: 40px;}
.create-time{margin-top: 20px;color: #545454;}
.item-detail a{}



.art-list{margin-top: 50px;}
.art-list .art-item{display: flex;border-top: #CCCCCC 1px solid;padding: 20px 0px 20px 0px;position: relative;}
.art-item .art-no{width: 50px;font-size: 28px;color: #CCCCCC;}
.art-item .art-title{}
.art-item .art-title .t1{font-size: 20px;font-weight: 500;color: #000000;}
.art-item .art-title .t2{font-size: 12px;color:#555555;}
.art-item .art-time{position: absolute;right: 40px;top: 30px;}
.art-item .icon{position: absolute;right: 0px;top: 30px;background: url(../../assets/img/article_icon.png) no-repeat center center;width: 31px;height: 22px;}



.pageStyle{padding-bottom: 100px;}




@media (max-width:1799px){

}
@media (max-width:1199px){
    .art-cate-title{width: 500px;}
    .art-cate-title-top{font-size: 30px;font-weight: 600;color: #000000;}
    .art-cate-title-center{font-size: 30px;font-weight: 600;color: #000000;}
    .art-cate-title-bottom{font-size: 16px;}

    .share{width: 220px;}
    .share-item.s1{width: 80px;height: 80px;}
    .share-item.s2{width: 80px;height: 80px;}


    .art-hot-item .item-pic{height: 200px;}
}
@media (max-width:993px){

}

@media (max-width:767px){
    .wraper-box{padding: 15px;}
    .tit-box{margin-top: 20px;}
    .art-cate-title{width: 100%;float: none;}
    .art-cate-title-top{font-size: 18px;font-weight: 600;color: #000000;}
    .art-cate-title-center{font-size: 18px;font-weight: 600;color: #000000;}
    .art-cate-title-bottom{font-size: 14px;}
    .share{display: none;}

    .art-hot-list{display: block;}
    .art-hot-item{width: 100%;margin-bottom: 30px;display: block;}
    .art-item .art-time{display: none;}
    .art-item .icon{display: none;}

    .item-left .item-title{font-size: 14px;}
    .art-item .art-title .t1{font-size: 14px;}


}


</style>
